var saveCartNote = function() {
  
  var cartNote = $('#msg_text textarea').val().trim();
  $('#msg_text textarea').addClass('note_saved');
  $('#msg_text textarea').css('cursor', 'not-allowed');
  $('#msg_text textarea').prop('disabled', 'true');
  
  var id = $('#gift-message').attr('data-id');
    
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1,
          properties: {
            'Gift Note': cartNote
          }
        }
      ]
    }),
  }).then(res => window.location = '/cart');

};

var removeCartNote = function() {
  
  $('#msg_text textarea').val('');
  $('#msg_text textarea').removeClass('note_saved');
  $('#msg_text textarea').css('cursor', 'initial');
  $('#msg_text textarea').prop('disabled', 'false');
  $('.checkbox-container').removeClass('hc-checked');
  $('.hc-characters').text('0');
  
  var id = $('#gift-message').attr('data-id');

    var id = $('#gift-message').attr('data-id');
    var headers = new Headers({ 'Content-Type': 'application/json' });

    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({updates: {[id]: 0}})
    };
    fetch('/cart/update.js', request)
    .then(function() {
      location.href = '/cart';
    });
};

var removeCartDrawerNote = function() {
  
  $('#msg_text textarea').val('');
  $('#msg_text textarea').removeClass('note_saved');
  $('#msg_text textarea').css('cursor', 'initial');
  $('#msg_text textarea').prop('disabled', '');
  $('.checkbox-container').removeClass('hc-checked');
  $('.checkbox-container').removeClass('hc-clicked');
  $('.hc-characters').text('0');
  
    var id = $('#hc-gift-message').attr('data-id');
    var headers = new Headers({ 'Content-Type': 'application/json' });
    
    var request = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({updates: {[id]: 0}})
    };
    fetch('/cart/update.js', request)
    .then(function(cart) {
      onCartUpdate(cart);
      fetchCart();
      removeProductFromCart();
      $('.og_btn').removeClass('hc-drawer-edit');
      $('.og_btn').html('Add Message');
      $('#msg_text textarea').text('');
      $('.og_btn').addClass('hc-drawer-add_msg');
      $('#msg_text textarea').text('');
      $('.hc-message').hide();
    });
};

var editCartNote = function() {

  var cartNote = $('#msg_text textarea').val().trim();
  $('#msg_text textarea').addClass('note_saved');
  $('#msg_text textarea').css('cursor', 'not-allowed');
  $('#msg_text textarea').prop('disabled', 'true');

  var id = $('#gift-message').attr('data-id');
  var headers = new Headers({ 'Content-Type': 'application/json' });

  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({updates: {[id]: 0}})
  };
  fetch('/cart/update.js', request)
  .then(function() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: id,
            quantity: 1,
            properties: {
              'Gift Note': cartNote
            }
          }
        ]
      }),
    }).then(res => window.location = '/cart');
  });
};

window.addEventListener('DOMContentLoaded',function(){
  
  $('[data-gift-note-html]').appendTo($('.order-summary__section__content'));

  var hc_handle = $('#gift-message').attr('data-product');
  $.ajax({
    type: "GET",
    url: '/products/' + hc_handle + '.js',
    dataType: "json",
    async: false
  }).done(function(product, textStatus, jqXHR) {
    $('#gift-message').attr('data-id', product.variants[0].id);
    $('.hc-free').text('$'+ (product.price / 100).toFixed(2));
  });
})

$('.add_msg').on('click', function() {
  saveCartNote();
});

$('.hc-edit').on('click', function() {
  editCartNote();
});

var saveCartNoteDrawer = function() {
  
  var cartNote = $('#msg_text textarea').val().trim();
  
  var id = $('#hc-gift-message').attr('data-id');
    
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: id,
          quantity: 1,
          properties: {
            'Gift Note': cartNote
          }
        }
      ]
    }),
  }).then(response => {
    return response.json();
  })
  .then(cart => {
    onCartUpdate(cart);
    fetchCart();
    $('.og_btn').removeClass('hc-drawer-add_msg');
    $('.og_btn').addClass('hc-drawer-edit');
    $('.og_btn').html('Edit Message');
    $('#msg_text textarea').addClass('note_saved');
    $('.hc-message').hide();
    $('.hc-input-custom').prop('checked', 'true');
  })
};

var editCartNoteDrawer = function() {

  var cartNote = $('#msg_text textarea').val().trim();
  $('#msg_text textarea').addClass('note_saved');
  $('.hc-message').hide();
  $('.hc-input-custom').attr('checked', 'true');

  var id = $('#hc-gift-message').attr('data-id');
  var headers = new Headers({ 'Content-Type': 'application/json' });

  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({updates: {[id]: 0}})
  };
  fetch('/cart/update.js', request)
  .then(function() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: id,
            quantity: 1,
            properties: {
              'Gift Note': cartNote
            }
          }
        ]
      }),
    }).then(response => {
      return response.json();
    })
    .then(cart => {
      onCartUpdate(cart);
      fetchCart();
    })
  });
};

/* HC - Cart adjustments - 28 Jul '22 */
$("textarea.field__input").keyup(function(e) {
  var val = $(this).val();
  var maxLength = 150;

var textlen;
  textlen = $(this).val().length;
if(textlen <= 150){
$('.hc-characters').text(textlen);

}
  $('textarea.field__input').val((val).substring(0, maxLength));
});

$(document).on('click', '.hc-drawer-add_msg', function() {
  saveCartNoteDrawer();
});

$(document).on('click', '.hc-drawer-edit', function() {
  editCartNoteDrawer();
});

$(document).on('click', '.hc-remove', function() {
  removeCartNote();
});
$(document).on('click', '.hc-drawer-remove', function() {
  removeCartDrawerNote();
});
$(document).on('click', '.hc-custom-label', function() {
  $('.hc-message').slideToggle('hc-shown');
  $(this).parent().toggleClass('hc-clicked');
  if($(this).parent().hasClass('hc-clicked')){
    $(this).parent().addClass('hc-checked');
  }else{
    if(!$('.og_btn').hasClass('hc-drawer-edit')){
      $(this).parent().removeClass('hc-checked');
    }
  }
});

$(document).on('click', '.hc-custom-cart-label', function() {
  $('.hc-message').slideToggle('hc-shown');
  $(this).parent().toggleClass('hc-clicked');
  if($(this).parent().hasClass('hc-clicked')){
    $(this).parent().addClass('hc-checked');
  }else{
    if(!$('.og_btn').hasClass('hc-edit')){
      $(this).parent().removeClass('hc-checked');
    }
  }
});

